import React, { useEffect, useContext, Fragment } from "react";

import { callApi } from "bodycodi/cmap/app/js/common.js";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";
import Message from "bodycodi/cmap/app/components/cmap8010/messageWrap";
import PartnerListPop from "./PartnerListPop";
import MyPagePop from "../cmap5010/myPagePop";
import AlramPop from "../cmap6010/alramPop";
import logo from "bodycodi/cmap/app/img/bodycodi-logo-small.png";
import coach_default from "bodycodi/cmap/app/img/member-profile-empty.png";
import icon_fold_arrow from "bodycodi/cmap/app/svg/icon_fold_arrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "bodycodi/cmap/app/redux/store";
import { fetchPartnerList } from "bodycodi/cmap/app/redux/slices/partnerSlice";

const HomeHeader = () => {
  const dispatchRedux = useDispatch<AppDispatch>();
  const {
    seqPartner,
    seqPartnerBranch,
    partnerName,
    partnerBranchName,
    partnerList: partnerBranchList,
  } = useSelector((state: RootState) => state.partner);
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  useEffect(() => {
    dispatchRedux(fetchPartnerList());
  }, []);

  useEffect(() => {
    callApi("/cmap8010/viewCoachImg", {}, "GET").then((res) => {
      dispatch({
        type: "UPDATE",
        data: {
          profileImg: res.CoachImgUrlVO?.imgUrl,
        },
      });
    });
  }, [seqPartner, seqPartnerBranch]);

  const handleOpenMyPagePop = () => {
    dispatch({ type: "POP_UP_OPEN", id: "MY_PAGE_POP", open: { myPagePop: true } });
  };

  const handleOpenCenterPop = () => {
    dispatch({ type: "POP_UP_OPEN", id: "CENTER_LIST_POP", open: { centerListPop: true } });
  };

  return (
    <Fragment>
      <div className="header">
        <div className="logo">
          <img src={logo} />
          <div className="line"></div>
        </div>
        {partnerBranchList.length ? (
          <div className="header-center" onClick={handleOpenCenterPop}>
            <div className="text">
              {partnerName} {partnerBranchName ? partnerBranchName : ""}
            </div>
            <img className="icon" src={icon_fold_arrow} />
          </div>
        ) : (
          <div className="header-center">
            <div className="text">{`등록된 센터 없음`}</div>
          </div>
        )}

        <Message />
        <img
          src={state.profileImg || coach_default}
          className="my-icon"
          onClick={handleOpenMyPagePop}
        />
      </div>
      <PartnerListPop
        partnerList={partnerBranchList}
        seqPartner={seqPartner}
        seqPartnerBranch={seqPartnerBranch}
      />
      <MyPagePop />
      <AlramPop />
    </Fragment>
  );
};

export default HomeHeader;
